
export const SET_CONTRACT_PARTIE_LOG = "SET_CONTRACT_PARTIE_LOG";
export function action_updateElementLog(logs) {
	return { type: SET_CONTRACT_PARTIE_LOG, payload: logs };
}

export const SET_FIRST_LOAD = "SET_FIRST_LOAD";
export function action_setFirstLoad(flag) {
	return { type: SET_FIRST_LOAD, payload: flag }
}
export const SET_FLY_POLINOMY_LIST = "SET_FLY_POLINOMY_LIST";
export function action_setFlyPolinomyList(polinomyList) {
	return { type: SET_FLY_POLINOMY_LIST, payload: polinomyList }
}
export const ADD_FLY_POLINOMY_LIST_ITEM = "ADD_FLY_POLINOMY_LIST_ITEM";
export function action_addFlyPolinomyListItem(polinomyItem) {
	return { type: ADD_FLY_POLINOMY_LIST_ITEM, payload: polinomyItem }
}
export const UPDATE_FLY_POLINOMY_LIST_ITEM = "UPDATE_FLY_POLINOMY_LIST_ITEM";
export function action_updateFlyPolinomyListItem(id, polinomyItem) {
	return { type: UPDATE_FLY_POLINOMY_LIST_ITEM, payload: {id, polinomyItem} }
}
export const REMOVE_FLY_POLINOMY_LIST_ITEM = "REMOVE_FLY_POLINOMY_LIST_ITEM";
export function action_removeFlyPolinomyListItem(itemId) {
	return { type: REMOVE_FLY_POLINOMY_LIST_ITEM, payload: itemId }
}



export const SET_SELECTED_FILTER_INDEX_LIST = "SET_SELECTED_FILTER_INDEX_LIST";
export function action_setSelectedFilterContractList(list) {
	return { type: SET_SELECTED_FILTER_INDEX_LIST, payload: list }
}
export const SET_FILTER_CONTRACT_LIST = "SET_FILTER_CONTRACT_LIST";
export function action_setFilterContractList(list) {
	return { type: SET_FILTER_CONTRACT_LIST, payload: list }
}
export const SET_FILTER_CONTRACT_ITEM = "SET_FILTER_CONTRACT_ITEM";
export function action_setFilterContractItem(item) {
	return { type: SET_FILTER_CONTRACT_ITEM, payload: item }
}
export const DELETE_FILTER_CONTRACT_ITEM = "DELETE_FILTER_CONTRACT_ITEM";
export function action_deleteFilterContractItem(item) {
	return { type: DELETE_FILTER_CONTRACT_ITEM, payload: item }
}

export const SET_SELECTED_FILTER_PERIOD = "SET_SELECTED_FILTER_PERIOD";
export function action_setSelectedFilterPeriod(period) {
	return { type: SET_SELECTED_FILTER_PERIOD, payload: period }
}
export const SET_SELECTED_FILTER_CONTRACT_LIST = "SET_SELECTED_FILTER_CONTRACT_LIST";
export function action_setSelectedFilterIndexList(listIds) {
	return { type: SET_SELECTED_FILTER_CONTRACT_LIST, payload: listIds }
}
export const SET_FILTER_INDEX_LIST = "SET_FILTER_INDEX_LIST";
export function action_setFilterIndexList(list) {
	return { type: SET_FILTER_INDEX_LIST, payload: list }
}
export const SET_FILTER_INDEX_ITEM = "SET_FILTER_INDEX_ITEM";
export function action_setFilterIndexItem(item) {
	return { type: SET_FILTER_INDEX_ITEM, payload: item }
}
export const DELETE_FILTER_INDEX_ITEM = "DELETE_FILTER_INDEX_ITEM";
export function action_deleteFilterIndexItem(item) {
	return { type: DELETE_FILTER_INDEX_ITEM, payload: item }
}




export const SET_CALCULATED_HEADER_IDS = "SET_CALCULATED_HEADER_IDS";
export function action_setCalculatedHeaderIds(listIds) {
	return { type: SET_CALCULATED_HEADER_IDS, payload: listIds }
}
export const ADD_CALCULATED_HEADER_ID = "ADD_CALCULATED_HEADER_ID";
export function action_addCalculatedHeaderId(item) {
	return { type: ADD_CALCULATED_HEADER_ID, payload: item }
}
export const REMOVE_CALCULATED_HEADER_ID = "REMOVE_CALCULATED_HEADER_ID";
export function action_RemoveCalculatedHeaderId(id) {
	return { type: REMOVE_CALCULATED_HEADER_ID, payload: id }
}
export const SET_CALCULATED_POLINOMY_IDS = "SET_CALCULATED_POLINOMY_IDS";
export function action_setCalculatedPolinomyIds(listIds) {
	return { type: SET_CALCULATED_POLINOMY_IDS, payload: listIds }
}
export const ADD_CALCULATED_POLINOMY_ID = "ADD_CALCULATED_POLINOMY_ID";
export function action_addCalculatedPolinomyId(item) {
	return { type: ADD_CALCULATED_POLINOMY_ID, payload: item }
}
export const REMOVE_CALCULATED_POLINOMY_ID = "REMOVE_CALCULATED_POLINOMY_ID";
export function action_removeCalculatedPolinomyId(id) {
	return { type: REMOVE_CALCULATED_POLINOMY_ID, payload: id }
}
export const SET_CALCULATED_CALCULATOR_IDS = "SET_CALCULATED_CALCULATOR_IDS";
export function action_setCalculatedCalculatorIds(listIds) {
	return { type: SET_CALCULATED_CALCULATOR_IDS, payload: listIds }
}
export const ADD_CALCULATED_CALCULATOR_ID = "ADD_CALCULATED_CALCULATOR_ID";
export function action_addCalculatedCalculatorId(item) {
	return { type: ADD_CALCULATED_CALCULATOR_ID, payload: item }
}
export const REMOVE_CALCULATED_CALCULATOR_ID = "REMOVE_CALCULATED_CALCULATOR_ID";
export function action_removeCalculatedCalculatorId(id) {
	return { type: REMOVE_CALCULATED_CALCULATOR_ID, payload: id }
}
export const UPDATE_SELECTED_TYPE = "UPDATE_SELECTED_TYPE";
export function action_updateSelectedType(type, selected) {
	return { type: UPDATE_SELECTED_TYPE, payload: {type, selected} }
}
export const SET_CONTRACTS = "SET_CONTRACTS";
export function action_setContracts(contractList) {
	return { type: SET_CONTRACTS, payload: contractList }
}
export const SET_POLINOMY_STRUCTURE_POLINOMY = "SET_POLINOMY_STRUCTURE_POLINOMY";
export function action_setPolinomyStructurePolinomy(structure) {
	return { type: SET_POLINOMY_STRUCTURE_POLINOMY, payload: structure }
}
export const SET_POLINOMY_STRUCTURE_POLINOMY_ITEM_CODIGOCONTRATO = "SET_POLINOMY_STRUCTURE_POLINOMY_ITEM_CODIGOCONTRATO";
export function action_setPolinomyStructurePolinomy_ItemCodigoContrato(itemStructure) {
	return { type: SET_POLINOMY_STRUCTURE_POLINOMY_ITEM_CODIGOCONTRATO, payload: itemStructure }
}
export const SET_POLINOMY_STRUCTURE_PARTIES = "SET_POLINOMY_STRUCTURE_PARTIES";
export function action_setPolinomyStructureParties(structure) {
	return { type: SET_POLINOMY_STRUCTURE_PARTIES, payload: structure }
}
export const SET_POLINOMY_STRUCTURE_CALCULATOR = "SET_POLINOMY_STRUCTURE_CALCULATOR";
export function action_setPolinomyStructureCalculator(structure) {
	return { type: SET_POLINOMY_STRUCTURE_CALCULATOR, payload: structure }
}